export default __webpack_public_path__ + "static/media/hero-image.e00add7b.webp";